import { useNavigationGuardContext } from "@jugl-web/domain-resources/common/providers/NavigationGuardProvider";
import {
  SideMenuList,
  SideMenuListItem,
  SideMenuPanel,
  MultiSectionLayout,
} from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React, { useMemo, useState } from "react";
import { useVoiceAccount } from "../../hooks/useVoiceAccount";
import { ReactComponent as GeneralIcon } from "./assets/general.svg";
import { ReactComponent as InfoIcon } from "./assets/info.svg";
import { ReactComponent as TransferIcon } from "./assets/transfer.svg";
import { GeneralTab } from "./components/GeneralTab";
import { HowItWorksTab } from "./components/HowItWorksTab";
import { TransferCallsTab } from "./components/TransferCallsTab";
import { VoiceAccountMenuTab } from "./types";

export const VoiceAccountScreen: React.FC = () => {
  const { t } = useTranslations();
  const { requestNavigation } = useNavigationGuardContext();
  const { account } = useVoiceAccount();

  const isTransferEnabled = !!account?.metadata?.handover_phone;

  const [selectedMenuTab, setSelectedMenuTab] = useState<VoiceAccountMenuTab>(
    VoiceAccountMenuTab.general
  );

  const sideMenuItems = useMemo(
    () => [
      {
        id: VoiceAccountMenuTab.general,
        label: t({
          id: "client-support-page.general",
          defaultMessage: "General",
        }),
        startIcon: <GeneralIcon />,
      },
      {
        id: VoiceAccountMenuTab.transferCalls,
        label: t({
          id: "client-support-page.transfer-calls",
          defaultMessage: "Transfer Calls",
        }),
        startIcon: <TransferIcon />,
        endIcon: (
          <span className="font-secondary text-xs text-dark-600">
            {isTransferEnabled
              ? t({ id: "common.on", defaultMessage: "On" })
              : t({ id: "common.off", defaultMessage: "Off" })}
          </span>
        ),
      },
      {
        id: VoiceAccountMenuTab.howItWorks,
        label: t({
          id: "client-support-page.how-it-works-title",
          defaultMessage: "How it works",
        }),
        startIcon: <InfoIcon />,
      },
    ],
    [isTransferEnabled, t]
  );

  return (
    <MultiSectionLayout
      classNames={{ content: "flex flex-col bg-grey-100" }}
      leftSide={
        <SideMenuPanel>
          <SideMenuList>
            {sideMenuItems.map((item) => (
              <SideMenuListItem
                key={item.id}
                label={item.label}
                startIcon={item.startIcon}
                endIcon={item.endIcon}
                isSelected={selectedMenuTab === item.id}
                onClick={() =>
                  requestNavigation(() => setSelectedMenuTab(item.id))
                }
              />
            ))}
          </SideMenuList>
        </SideMenuPanel>
      }
    >
      {selectedMenuTab === VoiceAccountMenuTab.general && <GeneralTab />}
      {selectedMenuTab === VoiceAccountMenuTab.transferCalls && (
        <TransferCallsTab />
      )}
      {selectedMenuTab === VoiceAccountMenuTab.howItWorks && <HowItWorksTab />}
    </MultiSectionLayout>
  );
};
